import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=07cd2ec6&scoped=true&"
import script from "./Show.vue?vue&type=script&lang=js&"
export * from "./Show.vue?vue&type=script&lang=js&"
import style0 from "./Show.vue?vue&type=style&index=0&id=07cd2ec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cd2ec6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07cd2ec6')) {
      api.createRecord('07cd2ec6', component.options)
    } else {
      api.reload('07cd2ec6', component.options)
    }
    module.hot.accept("./Show.vue?vue&type=template&id=07cd2ec6&scoped=true&", function () {
      api.rerender('07cd2ec6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Order/Show.vue"
export default component.exports